import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useTemplatesList() {

    //User toast
    const toast = useToast()

    const refTemplateListTable = ref(null)

    const tableColumns = [
        {key: 'id', sortable: true},
        {key: 'template_name'},
        {key: 'template_remark'},
        {key: 'template_main_title'},
        {key: 'template_sign_positoin'},
        {key: 'preview'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalTemplates = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refTemplateListTable.value ? refTemplateListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalTemplates.value,
        }
    })

    const refetchData = () => {
        refTemplateListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchTemplates = (ctx, callback) => {
        store.dispatch('contract_template/fetchTemplates',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {contract_templates, total} = response.data
            callback(contract_templates)
            totalTemplates.value = total
        
        })
        .catch((error) => {
            console.log(error)
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching template list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchTemplates,
        tableColumns,
        perPage,
        currentPage,
        totalTemplates,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTemplateListTable,
        ability,
        refetchData
    }

}